export default "__VITE_ASSET__9TZJUQ$R__"